import o from "./CustomHeading.vue2.js";
import t from "../../../../_virtual/_plugin-vue_export-helper.js";
const r = /* @__PURE__ */ t(o, [["__scopeId", "data-v-d8b932cb"]]);
export {
  r as default
};
